<template>
  <v-card flat fill-height style="width:400px;background-color:rgb(244,244,244);">
    <v-card-title class="title" style="color:rgb(51,82,128);height:55px;">Alerts</v-card-title>
    <v-card-text style="overflow:auto;padding:8px;max-height:400px;">
      <v-container fluid fill-height grid-list-md style="padding:5px;">
        <v-layout fill-height column>
          <!--{{alerts}}-->
          <v-flex v-for="item in alerts" :key="item">
            <v-card v-if="item.type == 'fault'" flat class="hoverCard" fill-height style="background-color:rgb(219,219,219);">
              <v-container fluid grid-list-md style="padding:5px;height:100%;">
                <v-layout row fill-height>
                  <v-flex d-flex md11>
                    <strong>Engine Fault</strong>
                  </v-flex>
                  <v-flex d-flex md1>
                    <a href="#" v-on:click="select(item)">
                      <font-awesome-icon icon="external-link-alt" />
                    </a>
                  </v-flex>
                </v-layout>
                <v-layout row fill-height>
                  <v-flex d-flex md4>
                    <v-layout column fill-height>
                      <v-flex d-flex v-for="param in parameters" :key="param" style="padding-left:10px;">
                        <label v-if="param == 'Vessel'"><input type="checkbox" style="margin-right: 8px;" class="noticeCheck" :value="item.notification"/>{{ param }} :</label>
                        <label v-else="" style="padding-left: 20px;">{{ param }} :</label>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex md5>
                    <v-layout column fill-height>
                      <v-flex d-flex v-for="param in parameters" :key="param">
                        <div v-if="param=='Fault'" class="hoverTitle" v-on:click="select(item)" style="width:100%;height:100%;">{{ item[param] }}</div>
                        <div v-else style="width:100%;height:100%;">{{ item[param] }}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex md3>{{ item.faultDatetime.slice(0, 10) }}<br>{{ item.faultDatetime.slice(11, 19) }}</v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-card v-else-if="item.type == 'maintenance_task'" flat class="hoverCard" fill-height style="background-color:rgb(219,219,219);">
              <v-container fluid grid-list-md style="padding:5px;height:100%;">
                <v-layout row fill-height>
                  <v-flex d-flex md11>
                    <strong>Maintenance Task</strong>
                  </v-flex>
                  <v-flex d-flex md1>
                    <a href="#" v-on:click="select(item)">
                      <font-awesome-icon icon="external-link-alt" />
                    </a>
                  </v-flex>
                </v-layout>
                <v-layout row fill-height>
                  <v-flex d-flex md5>
                    <v-layout column fill-height>
                      <v-flex d-flex v-for="param in Object.keys(maintenance_titles)" :key="param" style="padding-left:10px;">
                        <label v-if="param == 'Vessel'"><input type="checkbox" style="margin-right: 8px;" class="noticeCheck" :value="item.notification"/>{{ param }} :</label>
                        <label v-else="" style="padding-left: 20px;">{{ maintenance_titles[param] }} :</label>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex md5>
                    <v-layout column fill-height>
                      <v-flex d-flex v-for="param in Object.keys(maintenance_titles)" :key="param">
                        <div v-if="param=='action'" class="hoverTitle" v-on:click="select(item)" style="width:100%;height:100%;">{{ item[param] }}</div>
                        <div v-else style="width:100%;height:100%;">{{ item[param] }}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions style="height:70px;padding:8px;">
      <v-layout row style="width:100%;height:100%;">
        <v-flex d-flex md4>
          <v-btn flat @click="goToAlerts()" style="width:100%;height:100%;">Go to Alerts</v-btn>
        </v-flex>
        <v-flex d-flex md4>
          <v-btn flat style="width:100%;height:100%;" @click="dismissSelected()">Dismiss Selected</v-btn>
        </v-flex>
        <v-flex d-flex md4>
          <v-btn flat @click="dismissAll()" style="width:100%;height:100%;">Dismiss All</v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import {globalStore} from "../main.js"
import {vessels} from "../main.js"
import {getData} from "../getData.js";
import axios from 'axios'

var apiService;

export default {
  name: "AlertMenu",
  components: {},
  data() {
    return {
      parameters: ['Vessel', 'Component', 'Subsystem', 'Fault'],
      maintenance_titles: {
        'Vessel' : 'Vessel',
        'Component' : 'Component',
        'action' : 'Action',
        'engine' : 'Engine',
        'c_rh' : 'Current Hours',
        'pl_date' : 'Planned Date',
        'pr_date' : 'Prediction Date'

      },
    }
  },
  props: {
    menu: Boolean
  },
  created() {
    apiService = new getData(globalStore.userProfile, false);
  },
  computed: {
    alerts: function () {
      var alerts = [];

      globalStore.alerts.map((i) => {
        if (i.type == 'fault') {
          var fault = Object.assign({}, i);

          if (typeof fault.faultDatetime.date != 'undefined') {
            fault.faultDatetime = fault.faultDatetime.date;
          }

          if (fault.Fault) {
            alerts.push(fault)
          }
        } else if (i.type == 'maintenance_task') {
          alerts.push(i)
        }
      });

      return alerts;
    },
  },
  mounted() {
  },
  methods: {
    goToAlerts() {
      this.$router.push({name: 'Alerts'});
      this.$emit('update:menu', false);
    },
    dismissAll() {
      axios.post(globalStore.config.api_location + '/notifications/dismish/', {selected: []}, {headers: {Authorization: globalStore.auth_token}}).then(() => {
        globalStore.alerts = [];
      }).catch(() => {
        globalStore.alerts = [];
      });
      this.$emit('update:menu', false);
    },
    dismissSelected() {
      var notificationsChecked = document.querySelectorAll('.noticeCheck'),
          ids = [];

      for (var i in notificationsChecked) {
        if (notificationsChecked.hasOwnProperty(i) && notificationsChecked[i].checked) {
          ids.push(notificationsChecked[i].value);
        }
      }

      axios.post(globalStore.config.api_location + '/notifications/dismish/', {selected: ids}, {headers: {Authorization: globalStore.auth_token}}).then((response) => {
        globalStore.alerts = response.data.data;
      }).catch(() => {
      });
      this.$emit('update:menu', false);
    },
    select(item) {
      var vesselList = Object.values(vessels.vessels),
          vess = vesselList.find(vessel => vessel.name == item.Vessel);

      let url = new URL(window.location.origin)

      if (item.type == 'fault') {
        if (typeof item.faultDatetime.date != 'undefined') {
          globalStore.alertDate = item.faultDatetime.date.slice(0, 10);
        } else {
          globalStore.alertDate = item.faultDatetime.slice(0, 10);
        }

        globalStore.notificationId = item.notification;
        url.pathname += `engine-faults/${item.Vessel}`

        if (vess.has_twin) {
          url.pathname += `/engine/${item.faultEngine}`
        }

        url.pathname += `/on/${globalStore.alertDate}/fault/${item.Id}`
      } else if (item.type == 'maintenance_task') {
        url.pathname += `maintenance-tasks/${item.Vessel}/notification/${item.id}`
      }

      this.$router.push(url.pathname.toString())
    }
  },
  watch: {}
}
</script>

<style scoped>
.hoverTitle {
  color: rgb(95, 158, 239);
}

.hoverTitle:hover {
  color: rgb(51, 82, 128);
}
</style>

